import React, { useEffect } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import "./NotificationPage.css";
import BlueButton from "../Button/BlueButton";
import showToast from "../Toast/Toster";
import { Box } from "@mui/material";
import { getItem } from "../../utils/storage";

const Notifications = ({ fetchNotifications, viewAll, isDonationMode, handleCloseNotifications }) => {
  const handleViewAll = async () => {
    try {
      const CustomerId = getItem("CustomerId");
      const WorkerId = getItem("worker_id");
      const DonorId = getItem("DonorId");

      let response = await AxiosInstance.put(`/v1/notification/view-all`, {
        CustomerId: CustomerId,
        WorkerId: WorkerId,
        DonorId: DonorId,
      });
      if (response?.status === 200) {
        showToast.success("All notifications marked as viewed!");

        viewAll();
      }
    } catch (error) {
      showToast.error("Error updating notifications");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
      <BlueButton
        className={` text-white-color ${
          isDonationMode ? "bg-donor-color" : "bg-blue-color"
        }`}
        style={{
          fontSize: "10px",
          cursor: "pointer",
          border: "none",
        }}
        onClick={handleViewAll}
        label="Mark All as Read"
      />
    </Box>
  );
};

export default Notifications;
